import { ButtonGroup, IconButton, Pagination } from "@chakra-ui/react"
import { FiArrowLeft, FiArrowRight } from "react-icons/fi"

type PaginationBaseProps = {
  count: number
  pageSize: number
  page: number
  onPageChange: (newPage: { page: number }) => void
}


const PaginationBase = ({ count, pageSize, page, onPageChange }: PaginationBaseProps) => {
  return (
    <Pagination.Root count={count} pageSize={pageSize} page={page} defaultPage={1} onPageChange={onPageChange}>
      <ButtonGroup variant="ghost" size="sm" display="flex" justifyContent="center">
        <Pagination.PrevTrigger asChild marginRight={20}>
          <IconButton
            borderRadius="full"
            aria-label="Previous Page"
            borderColor="main">
            <FiArrowLeft />
          </IconButton>
        </Pagination.PrevTrigger>

        <Pagination.Items
          render={(page) => (
            <IconButton
              key={page.value}
              borderRadius="full"
              _selected={{
                bg: "main",
                color: "#fff",
              }}
            >
              {page.value}
            </IconButton>
          )}
        />

        <Pagination.NextTrigger asChild marginLeft={20}>
          <IconButton
            borderRadius="full"
            aria-label="Next Page"
            borderColor="main">
            <FiArrowRight />
          </IconButton>
        </Pagination.NextTrigger>
      </ButtonGroup>
    </Pagination.Root>
  )
}

export default PaginationBase
